module.exports = __webpack_public_path__ + "media/assets/images/forbidden_mark_black-fb3783165050ff81bd39c486d98ee60c.png";